<script setup>
import { defineEmits, defineProps, ref } from "vue";
import { useClipboard } from "@vueuse/core";

const props = defineProps({
  title: String,
  value: String,
  closeText: String,
});

const { copy } = useClipboard({ source: props.value });

const emits = defineEmits(["close"]);

const input = ref(null);

function onCopyClick() {
  copy();
  input.value?.select();
}

function close() {
  emits("close");
}
</script>

<template>
  <div class="popup-bg on"></div>
  <div class="popup-cont on">
    <div class="popup-header">
      <h3 v-if="title" class="title">{{ title }}</h3>
      <h3 v-else class="title">공유하기</h3>
      <button type="button" class="popup-close-btn popup-close" @click="close">
        <template v-if="closeText">{{ closeText }}</template>
        <template v-else>닫기</template>
      </button>
    </div>
    <div class="popup-body width-share">
      <div class="popup-share">
        <div class="share-btns" style="display: none"></div>
        <div class="share-link">
          <input ref="input" type="text" readonly :value="value" />
          <button class="share-btns" @click="onCopyClick">공유하기</button>
        </div>
      </div>
    </div>
  </div>
</template>
